export default __webpack_public_path__ + "static/media/server-load-bg.0d1009f3.png";